<!-- progress -->
<div class="progress" style="margin-top:38px">
    <div class="progress-bar" role="progressbar" aria-label="Basic example" style="width:70%" aria-valuenow="25"
        aria-valuemin="0" aria-valuemax="100"></div>
</div>
<!-- Main Page Start -->
<section class="pd-tb">
    <div class="container">
        <div class="verificationWrap setPassword">
            <div class="subHeader">
                <h2 class="heading2 mb-2"> Authenticity is the core of any mission’s success </h2>
                <p> Please upload the following document and provide MOS code to help us serve you better. </p>
            </div>
            <form [formGroup]="form" (ngSubmit)="onSubmit()">
                <div class="form-group">
                    <div class="input-group custom-file-button">
                        <label class="input-group-text" for="uploadbanner" *ngIf="haveFileName == null"><i><img
                                    src="assets/images/ic_upload.svg"> </i> Upload document </label>
                        <label class="input-group-text" for="uploadbanner"
                            *ngIf="haveFileName != null">{{fileName}}<input type="file" class="form-control"
                                id="uploadbanner" #myInput (change)="upload($event)" value="Upload Photo"
                                accept=".jpg,.jpeg,.pdf"></label>
                        <input type="file" class="form-control" id="uploadbanner" #myInput (change)="upload($event)"
                            value="Upload Photo" accept=".jpg,.jpeg,.pdf">
                    </div>
                    <p class="explain" [ngClass]="fileSize == true ? 'text-danger':''"> Max file size - 5mb & You should only upload JPEG or PDF file. </p> 

                    <div class="text-danger" *ngIf="showError && haveFileName == null">
                        *Please Upload document.
                    </div>
                </div>
                <div class="form-group" *ngIf="userData?.userType == 1 && veteranRelationName == 1">
                    <div class="input-group custom-file-button">
                        <label class="input-group-text" for="uploadVeteranbanner"
                            *ngIf="haveVeternFileName == null"><i><img src="assets/images/ic_upload.svg"> </i> Upload
                            Veteran Relation document </label>
                        <label class="input-group-text" for="uploadVeteranbanner"
                            *ngIf="haveVeternFileName != null">{{vetFileName}}<input type="file" class="form-control"
                                id="uploadVeteranbanner" #myInputDoc (change)="uploadVeteranDoc($event)"
                                value="Upload Photo" accept=".jpg,.jpeg,.pdf"></label>
                        <input type="file" class="form-control" id="uploadVeteranbanner" #myInputDoc
                            (change)="uploadVeteranDoc($event)" value="Upload Photo" accept=".jpg,.jpeg,.pdf">
                    </div>
                    <p class="explain" [ngClass]="fileSizeVeteranRelation == true ? 'text-danger':''"> Max file size -
                        5mb </p>

                    <div class="text-danger" *ngIf="showError && haveVeternFileName == null">
                        *Please Upload document.
                    </div>
                </div>
                <div class="form-group pb-4" *ngIf="userData?.userType == 1">
                    <label>{{veteranRelationName == 2?'Child (veteran) details':veteranRelationName == 3?'Parent (veteran) details':'Spouse Name'}} </label>
                    <input type="text" class="form-control" [placeholder]="'Please Enter ' + (veteranRelationName == 2?'Child (veteran) details':veteranRelationName == 3?'Parent (veteran) details':'Spouse Name')"
                        formControlName="veteranRelationName" />
                </div>
                <div class="form-group pb-2">
                    <label> Service<span class="orangeText">*</span> </label>
                    <div class="icon_div">
                        <select id="state" class="form-control" name="serviceId" formControlName="serviceId"
                            (ngModelChange)="selectedService($event)">
                            <option *ngFor="let data of serviceList;let i=index;" [value]="data.id">{{data.name}}
                            </option>
                        </select>
                        <div class="text-danger" *ngIf="form.controls['serviceId'].hasError('required') && showError">
                            *Please enter service.
                        </div>
                    </div>
                </div>
                <div class="form-group pb-4" *ngIf="showOtherService">
                    <label>Other Service Title<span class="orangeText">*</span> </label>
                    <input type="text" class="form-control" placeholder="Other Service Title "
                        formControlName="otherServiceTitle" />
                    <div class="text-danger"
                        *ngIf="showOtherService && form.value.otherServiceTitle == '' && showError">
                        *Please enter Other Service Title.
                    </div>
                </div>
                <div class="form-group pb-3">
                    <label> Military Job Title<span class="orangeText">*</span> </label>
                    <!-- <input type="text" class="form-control" name="militaryJobTitle"
                        placeholder="00H Enlisted Aide (Army - Enlisted) " formControlName="militaryJobTitle"
                        id="militaryJobTitle" maxlength="30" /> -->  
                    <ng-multiselect-dropdown  formControlName="JobTitle" class="form-control noBorder px-0 multiDrop" [placeholder]="'Select'" [settings]="dropdownSettingsMilitary" [data]="allMosCode" ></ng-multiselect-dropdown>
                    
                    <div class="text-danger"
                        *ngIf="form.controls['JobTitle'].hasError('required') && showError">
                        *Please enter military Job Title.
                    </div>
                    <!-- <div class="text-danger"
                        *ngIf="form.controls['militaryJobTitle'].hasError('minlength') && showError">
                        *Minimum length of 3 characters.
                    </div> -->
                </div>
                <div class="row" *ngIf="userData?.userType == 1">
                    <div class="col-lg-12 col-md-12 col-sm-12">
                        <div class="form-group">
                            <div>
                                <label> Honors and Awards </label>
                                <div class="p-relative">
                                    <input type="text" class="form-control" placeholder="Enter" #hAwards>
                                    <a href="javascript:void(0);" class="addMore"
                                        (click)="addMore(hAwards, hAwards.value)"><img
                                            src="../../../../assets/images/add-circle.svg" /></a>
                                </div>
                                <div class="text-danger"
                                    *ngIf="form.controls['honorAwardArray'].hasError('required') && showError">
                                    *Please enter Honor and Awards.
                                </div>
                            </div>
                            <div class="row" style="padding-top: 10px;">
                                <div class="col-md-6 col-sm-12"
                                    *ngFor="let awards of awardList;let i=index">
                                    <div class="joinservice"><span> {{awards?.name}}</span><a href="javascript:void(0)"
                                            (click)="deleteLanguage(awards)"><img src="assets/images/ic_delete.svg">
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="form-group" *ngIf="userData?.userType == 1">
                    <label>Is the veteran service-disabled?<span class="orangeText">*</span></label>
                    <div class="d-flex spaceRight radioWrap pt-3">
                        <input type="radio" id="yes" [value]="1" name="serviceDisabled"
                            formControlName="serviceDisabled" [(ngModel)]="actionUpload">
                        <label for="yes"> Yes </label>
                        <input type="radio" id="no" [value]="2" name="serviceDisabled" formControlName="serviceDisabled"
                            [(ngModel)]="actionUpload">
                        <label for="no"> No </label>
                    </div>
                    <div class="text-danger" *ngIf="form.controls['serviceDisabled'].hasError('required') && showError">
                        *Please select Are you service-disabled.
                    </div>
                    <div class="text-danger" *ngIf="showError && form.value.serviceDisabled == 0">
                        *Please select Are you service-disabled.
                    </div>
                </div>
                <div class="form-group">
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="customCheckBox1"
                            formControlName="isRequired" [checked]="form.value.isRequired ==1"
                            (change)="form.value.isRequired ==1">

                        <label class="custom-control-label" for="customCheckBox1"> I authorize HonorVet to verify my
                            details as per <a href="/terms" routerLink="/terms" target="_blank"  class="orangeText"> Terms and Conditions </a> and <a href="/privacy" routerLink="/privacy"  target="_blank" class="orangeText"> Privacy Policy </a> </label>
                    </div>
                    <div class="text-danger" *ngIf="form.value.isRequired != 1 && showError">
                        *Please select the checkbox to accept terms and conditions..
                    </div>
                </div>
                <div class="form-group">
                    <input type="submit" class="commonBtn mt-2" value="Continue">
                </div>
            </form>
        </div>
    </div>
</section>